import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractType } from './abstract-type';
import { AbstractModel, DateFormatConstants, DateUtil, isNullOrUndefined } from '@uzurv/core';
import moment from 'moment-timezone';

@inheritSerialization(AbstractModel)
export class FileUpload extends AbstractModel {
  @autoserialize
  fileName: string;

  @autoserialize
  personFullName: string;

  @autoserialize
  startedDate: Date;

  @autoserialize
  completedDate: Date;

  @autoserialize
  rowCount: number;

  @autoserializeAs(AbstractType)
  fileUploadStatus: AbstractType;

  @autoserialize
  hasErrorFile: boolean;

  get formattedStartedDate(): string {
    if (isNullOrUndefined(this.startedDate)) {
      return null;
    }

    return moment(this.startedDate).format(DateFormatConstants.DATE_FORMAT_SHORT_TIMEZONE);
  }

  get formattedCompletedDate(): string {
    if (isNullOrUndefined(this.completedDate)) {
      return null;
    }

    return moment(this.completedDate).format(DateFormatConstants.DATE_FORMAT_SHORT_TIMEZONE);
  }

  static OnSerialized(instance: FileUpload, json: any): void {
    if (!isNullOrUndefined(instance.startedDate)) {
      json.startedDate = DateUtil.serializeInstant(instance.startedDate);
    }

    if (!isNullOrUndefined(instance.completedDate)) {
      json.completedDate = DateUtil.serializeInstant(instance.completedDate);
    }
  }

  static OnDeserialized(instance: FileUpload, json: any): void {
    if (!isNullOrUndefined(json['startedDate'])) {
      instance.startedDate = DateUtil.deserializeInstant(json['startedDate']);
    }

    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeInstant(json['completedDate']);
    }
  }
}
